import { Box, Button, Card, Typography } from '@occc-app/design-system';

type ScheduleEmptyStateProps = {
  onClick: () => void;
};

export const ScheduleEmptyState = ({ onClick }: ScheduleEmptyStateProps) => {
  return (
    <Box>
      <Card sx={{ p: 4, mb: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ maxWidth: 456 }}>
          <Typography align='center' fontWeight={500} mb={2} variant='body1'>
            No Ad Sets to Display
          </Typography>
          <Typography align='center' variant='body1'>
            To view the schedule, please select a terminal or kiosk ID. Ad sets are shown based on
            the selected kiosk's schedule.
          </Typography>
          <Typography align='center' mb={4} variant='body1'>
            You can select{' '}
            <Box component='span' sx={{ color: 'primary.main.dark', fontWeight: 500 }}>
              up to two kiosks
            </Box>{' '}
            at once.
          </Typography>
          <Button fullWidth variant='contained' onClick={onClick}>
            SELECT KIOSK/TERMINAL
          </Button>
        </Box>
      </Card>
    </Box>
  );
};
